import colors from 'vuetify/es5/util/colors';

export const LOCALE = 'en_AU';
export const COLOURS = Object.keys(colors)
  .filter(colour => !['brown', 'shades'].includes(colour))
  .map(key => Object.values(colors[key]).filter(colour => !['#e65100'].includes(colour)))
  .flat();